module.exports = function getResource (label, vars = []) {
    let resources = {
        checkoutButton: 'Checkout',
        continueToCheckoutButton: 'Continue to Checkout'

    };
    return resources[label];
};
